'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

var _components = require('components');

var _EmailFormValidation = require('./EmailFormValidation');

var _EmailFormValidation2 = _interopRequireDefault(_EmailFormValidation);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var accountEmailFormDefaults = {
  email: ''
};

var AccountEmailForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addEmailLoading: state.account.addEmailLoading
  };
}, { addEmail: _account.addEmail }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'AccountEmailForm',
  propNamespace: 'accountEmailForm',
  initialValues: accountEmailFormDefaults,
  validate: _EmailFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AccountEmailForm, _Component);

  function AccountEmailForm() {
    (0, _classCallCheck3.default)(this, AccountEmailForm);
    return (0, _possibleConstructorReturn3.default)(this, (AccountEmailForm.__proto__ || (0, _getPrototypeOf2.default)(AccountEmailForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountEmailForm, [{
    key: 'addEmail',
    value: function addEmail(formData) {
      var email = formData.email;

      if (!email) {
        return false;
      }

      var _props = this.props,
          t = _props.t,
          reset = _props.accountEmailForm.reset;

      var promise = this.props.addEmail(email).promise;
      promise.then(function () {
        _toastr2.default.info(t('An email has been sent.'));
        reset();
      });
      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          _props2$accountEmailF = _props2.accountEmailForm,
          handleSubmit = _props2$accountEmailF.handleSubmit,
          submitting = _props2$accountEmailF.submitting,
          addEmailLoading = _props2.addEmailLoading;


      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.addEmail) },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-60 col-sm-45 col-md-35 col-lg-30' },
            _react2.default.createElement(
              _reduxForm.Field,
              { type: 'email', name: 'email', component: _formComponents.formLineTextInput, placeholder: t('Enter email'), hideLabel: true },
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'btn btn-simple squared small pos-rel', disabled: submitting },
                t('Add'),
                addEmailLoading && _react2.default.createElement(_components.Loader, { mask: true })
              )
            )
          )
        )
      );
    }
  }]);
  return AccountEmailForm;
}(_react.Component), _class3.propTypes = {
  accountEmailForm: _propTypes2.default.object,
  addEmail: _propTypes2.default.func,
  addEmailLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addEmail', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addEmail'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = AccountEmailForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/EmailForm.js
// module id = 1938
// module chunks = 1